export default __webpack_public_path__ + "static/Leaving the session map and exiting classroom FINISHED-19c03e84e8fe2d5295693fe9e2b5f23c.mp4";